<div class="w-full border border-gray-200 rounded-3xl p-4 px-5 bg-white">
  <!-- All Properties Checkbox -->
  <div class="pb-2 mb-2">
    <mat-checkbox [checked]="allProperties()" (change)="onAllPropertiesChange($event.checked)" class="w-full">
      <span class="text-sm font-medium pl-2">All properties</span>
    </mat-checkbox>
  </div>

  <!-- Search Bar -->
  @if (hasSearchBar()) {
    <div class="mb-4">
      <!-- @TODO: Generic search bar in ui lib -->
      <mat-form-field class="w-full" appearance="outline" subscriptSizing="dynamic">
        <ui-icon icon="griddy-search" [size]="18" matPrefix class="text-gray-400 ml-2"></ui-icon>
        <input matInput type="text" placeholder="Search..." [formControl]="searchTerm" />
      </mat-form-field>
    </div>
  }

  <!-- Properties List -->
  @if (loading()) {
    <div class="p-4 text-center">
      <ui-loading-spinner></ui-loading-spinner>
    </div>
  } @else {
    <cdk-virtual-scroll-viewport [itemSize]="48" class="h-[400px]">
      <mat-checkbox
        *cdkVirtualFor="let property of filteredProperties(); trackBy: trackByPropertyId"
        [checked]="isPropertySelected()(property.id)"
        [disabled]="allProperties()"
        (change)="onPropertyToggle(property.id, $event.checked)"
        class="block w-full h-12 px-1">
        <div class="flex items-center gap-3 pl-2 h-full">
          <img
            [src]="property.picture"
            alt=""
            class="h-8 w-8 rounded object-cover flex-shrink-0"
            onerror="this.style.display='none'" />
          <div class="text-sm text-gray-700 truncate">
            {{ property.name }}
          </div>
        </div>
      </mat-checkbox>
    </cdk-virtual-scroll-viewport>
  }

  <!-- Footer Info -->
  @if (!loading()) {
    <div class="pt-2 mt-2 text-center text-sm text-gray-500">
      @if (allProperties()) {
        <span>All {{ totalProperties() }} properties selected</span>
      } @else {
        <span>{{ selectedCount() }} selected</span>
        @if (searchTerm.value) {
          <span> ({{ filteredProperties().length }} of {{ totalProperties() }} shown)</span>
        }
      }
    </div>
  }
</div>
